/* BIN-B extras (additive, safe)
   1) Hide sold-out variant options (colors/sizes with no available variant)
   2) Product page FREE-delivery hint near add-to-cart (Buy 2 = free delivery)
   3) Estimated delivery (3-6 working days)
*/
(function(){
  'use strict';

  /* ── 1. HIDE SOLD-OUT OPTIONS ── */
  function hideSoldOut(){
    var container = document.querySelector('[data-section-type="product"]');
    if(!container) return;

    var jsonEl = container.querySelector('[data-product-json]');
    if(!jsonEl) return;

    var data;
    try { data = JSON.parse(jsonEl.innerHTML); } catch(e){ return; }

    var variants = data.variants || [];
    var optNames = (data.options || []).map(function(o){
      return (o && o.name) ? o.name : o;
    });
    if(!variants.length || !optNames.length) return;

    optNames.forEach(function(optName, idx){
      var allValues = [];
      var availableValues = {};

      variants.forEach(function(v){
        var val = v.options[idx];
        if(val == null) return;
        if(allValues.indexOf(val) === -1) allValues.push(val);
        if(v.available) availableValues[val] = true;
      });

      var deadValues = allValues.filter(function(val){ return !availableValues[val]; });
      if(!deadValues.length) return;
      if(deadValues.length >= allValues.length) return;

      deadValues.forEach(function(val){
        var swatches = document.querySelectorAll('.binb-cs[data-color]');
        Array.prototype.forEach.call(swatches, function(btn){
          if(btn.getAttribute('data-color') === val){
            btn.setAttribute('data-binb-soldout','1');
            btn.style.display = 'none';
          }
        });

        var sel = container.querySelector('select[name="options[' + optName + ']"]');
        if(sel){
          Array.prototype.forEach.call(sel.options, function(op){
            if(op.value === val){
              op.disabled = true;
              op.setAttribute('data-binb-soldout','1');
              op.style.display = 'none';
            }
          });
          if(sel.value === val){
            for(var i=0;i<sel.options.length;i++){
              if(!sel.options[i].disabled){
                sel.value = sel.options[i].value;
                try { sel.dispatchEvent(new Event('change',{bubbles:true})); } catch(e){}
                break;
              }
            }
          }
        }

        var radio = container.querySelector(
          'input[type="radio"][name="options[' + optName + ']"][value="' + val.replace(/"/g,'\\"') + '"]'
        );
        if(radio){
          radio.setAttribute('data-binb-soldout','1');
          radio.disabled = true;
          var lbl = radio.id ? container.querySelector('label[for="' + radio.id + '"]') : null;
          if(lbl) lbl.style.display = 'none';
          radio.style.display = 'none';
        }
      });

      var countEl = document.querySelector('.binb-color-panel__count');
      if(countEl){
        var visible = document.querySelectorAll('.binb-cs:not([data-binb-soldout])').length;
        if(visible > 0) countEl.textContent = visible + ' options';
      }
    });
  }

  /* ── 2. PRODUCT PAGE FREE-DELIVERY HINT ── */
  var FD_THRESHOLD = 2;

  function injectHintStyles(){
    if(document.getElementById('binb-fdp-style')) return;
    var css = ''
      + '.binb-fdp{margin:12px 0 14px;padding:11px 13px;border-radius:12px;'
      + 'background:linear-gradient(135deg,#fffbeb,#fef3c7);border:1.5px solid #fcd34d}'
      + '.binb-fdp--done{background:linear-gradient(135deg,#f0fdf4,#dcfce7);border-color:#86efac}'
      + '.binb-fdp__msg{font-size:13px;font-weight:600;color:#0d0d0d;line-height:1.45;'
      + 'text-align:center;margin:0 0 8px}'
      + '.binb-fdp__msg b{color:#b45309}'
      + '.binb-fdp--done .binb-fdp__msg b{color:#166534}'
      + '.binb-fdp__track{height:7px;background:rgba(0,0,0,.08);border-radius:20px;overflow:hidden}'
      + '.binb-fdp__fill{height:100%;border-radius:20px;transition:width .45s ease;'
      + 'background:linear-gradient(90deg,#c9a84c,#f0d080)}'
      + '.binb-fdp--done .binb-fdp__fill{background:linear-gradient(90deg,#22c55e,#4ade80)}';
    var s = document.createElement('style');
    s.id = 'binb-fdp-style';
    s.textContent = css;
    document.head.appendChild(s);
  }

  function buildHint(){
    var container = document.querySelector('[data-section-type="product"]');
    if(!container) return null;
    if(document.getElementById('binb-fdp')) return document.getElementById('binb-fdp');

    var atc = container.querySelector('[data-add-to-cart]');
    if(!atc) return null;

    injectHintStyles();

    var box = document.createElement('div');
    box.id = 'binb-fdp';
    box.className = 'binb-fdp';
    box.innerHTML =
      '<p class="binb-fdp__msg" data-fdp-msg></p>' +
      '<div class="binb-fdp__track"><div class="binb-fdp__fill" data-fdp-fill style="width:0%"></div></div>';

    var anchor = atc.closest('.product__submit__buttons') || atc.closest('.product__submit') || atc.parentNode;
    if(anchor && anchor.parentNode){
      anchor.parentNode.insertBefore(box, anchor);
    } else {
      atc.parentNode.insertBefore(box, atc);
    }
    return box;
  }

  function renderHint(cartCount){
    var box = buildHint();
    if(!box) return;

    // Counting the item they are about to add
    var effective = cartCount + 1;
    var left = Math.max(0, FD_THRESHOLD - effective);
    var pct  = Math.min(100, Math.round(effective * 100 / FD_THRESHOLD));

    var msg  = box.querySelector('[data-fdp-msg]');
    var fill = box.querySelector('[data-fdp-fill]');

    if(left <= 0){
      box.classList.add('binb-fdp--done');
      if(msg) msg.innerHTML = '🎉 Mubarak! Is order par <b>Delivery FREE</b> — aap ne 2 items le liye ✅';
    } else {
      box.classList.remove('binb-fdp--done');
      if(msg) msg.innerHTML = '🎁 <b>OFFER:</b> Koi bhi <b>2 items</b> lein — <b>Delivery bilkul FREE</b>!<br><span style="font-weight:700;color:#b45309">Bas ' + left + ' aur item add karein → Rs 249 bach jayenge</span>';
    }
    if(fill) fill.style.width = pct + '%';
  }

  function refreshHint(){
    if(!document.querySelector('[data-section-type="product"]')) return;
    fetch('/cart.js', {headers:{Accept:'application/json'}})
      .then(function(r){ return r.json(); })
      .then(function(c){ renderHint(c.item_count || 0); })
      .catch(function(){ renderHint(0); });
  }

  /* ── 3. ESTIMATED DELIVERY (3-6 working days) ── */
  function injectEtaStyles(){
    if(document.getElementById('binb-eta-style')) return;
    var css = ''
      + '.binb-eta{margin:12px 0 14px;padding:13px 14px;border-radius:12px;'
      + 'background:#fff;border:1px solid #ececec}'
      + '.binb-eta__msg{font-size:12.5px;font-weight:600;color:#0d0d0d;line-height:1.45;margin:0 0 12px}'
      + '.binb-eta__msg b{color:#0d0d0d}'
      + '.binb-eta__date{color:#b45309}'
      + '.binb-eta__track{position:relative;display:flex;justify-content:space-between;'
      + 'align-items:flex-start;padding-top:14px}'
      + '.binb-eta__line{position:absolute;top:18px;left:12%;right:12%;height:2px;'
      + 'background:#f0f0f0;border-radius:2px;overflow:hidden}'
      + '.binb-eta__line::after{content:"";position:absolute;top:0;left:0;height:100%;width:40%;'
      + 'background:linear-gradient(90deg,transparent,#c9a84c,transparent);'
      + 'animation:binbEtaFlow 2.6s ease-in-out infinite}'
      + '@keyframes binbEtaFlow{0%{transform:translateX(-100%)}100%{transform:translateX(320%)}}'
      + '.binb-eta__step{position:relative;z-index:2;flex:1;text-align:center}'
      + '.binb-eta__dot{width:9px;height:9px;border-radius:50%;background:#e5e5e5;'
      + 'margin:0 auto 6px;border:2px solid #fff;box-shadow:0 0 0 1px #e5e5e5}'
      + '.binb-eta__step--on .binb-eta__dot{background:#c9a84c;box-shadow:0 0 0 1px #c9a84c}'
      + '.binb-eta__step--last .binb-eta__dot{background:#22c55e;box-shadow:0 0 0 1px #22c55e;'
      + 'animation:binbEtaPulse 2s ease-in-out infinite}'
      + '@keyframes binbEtaPulse{0%,100%{transform:scale(1)}50%{transform:scale(1.35)}}'
      + '.binb-eta__lbl{font-size:9.5px;font-weight:600;color:#8a8a8a;letter-spacing:.04em;'
      + 'text-transform:uppercase;line-height:1.3}'
      + '.binb-eta__sub{font-size:10px;color:#a5a5a5;margin-top:2px;font-weight:500}'
      + '@media(prefers-reduced-motion:reduce){'
      + '.binb-eta__line::after,.binb-eta__step--last .binb-eta__dot{animation:none}}';
    var s2 = document.createElement('style');
    s2.id = 'binb-eta-style';
    s2.textContent = css;
    document.head.appendChild(s2);
  }

  function addWorkingDays(from, days){
    var d = new Date(from.getTime());
    var added = 0;
    while(added < days){
      d.setDate(d.getDate() + 1);
      if(d.getDay() !== 0) added++;   // Sunday off
    }
    return d;
  }

  function fmtDate(d){
    var days = ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'];
    var mon  = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
    return days[d.getDay()] + ', ' + d.getDate() + ' ' + mon[d.getMonth()];
  }

  function buildEta(){
    var container = document.querySelector('[data-section-type="product"]');
    if(!container) return;
    if(document.getElementById('binb-eta')) return;

    var atc = container.querySelector('[data-add-to-cart]');
    if(!atc) return;

    injectEtaStyles();

    var now = new Date();
    // after 6pm -> dispatch next day
    var start = new Date(now.getTime());
    if(now.getHours() >= 18) start.setDate(start.getDate() + 1);
    if(start.getDay() === 0) start.setDate(start.getDate() + 1);

    var d1 = addWorkingDays(start, 3);
    var d2 = addWorkingDays(start, 6);

    var box = document.createElement('div');
    box.id = 'binb-eta';
    box.className = 'binb-eta';
    box.innerHTML =
      '<p class="binb-eta__msg">🚚 Abhi order karein — aapke ghar <b class="binb-eta__date">'
      + fmtDate(d1) + ' se ' + fmtDate(d2) + '</b> tak pohanch jayega</p>'
      + '<div class="binb-eta__track">'
      + '<div class="binb-eta__line"></div>'
      + '<div class="binb-eta__step binb-eta__step--on"><div class="binb-eta__dot"></div>'
      + '<div class="binb-eta__lbl">Order</div><div class="binb-eta__sub">Aaj</div></div>'
      + '<div class="binb-eta__step binb-eta__step--on"><div class="binb-eta__dot"></div>'
      + '<div class="binb-eta__lbl">Dispatch</div><div class="binb-eta__sub">'
      + fmtDate(addWorkingDays(start, 1)).split(',')[1].trim() + '</div></div>'
      + '<div class="binb-eta__step binb-eta__step--last"><div class="binb-eta__dot"></div>'
      + '<div class="binb-eta__lbl">Delivery</div><div class="binb-eta__sub">'
      + fmtDate(d1).split(',')[1].trim() + ' – ' + fmtDate(d2).split(',')[1].trim() + '</div></div>'
      + '</div>';

    var fdp = document.getElementById('binb-fdp');
    if(fdp && fdp.parentNode){
      fdp.parentNode.insertBefore(box, fdp);
      return;
    }
    var anchorEl = atc.closest('.product__submit__buttons') || atc.closest('.product__submit') || atc.parentNode;
    if(anchorEl && anchorEl.parentNode){ anchorEl.parentNode.insertBefore(box, anchorEl); }
    else { atc.parentNode.insertBefore(box, atc); }
  }

  /* ── BOOT ── */
  function schedule(){
    hideSoldOut();
    setTimeout(hideSoldOut, 300);
    setTimeout(hideSoldOut, 1200);
    refreshHint();
    buildEta();
    setTimeout(buildEta, 400);
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', schedule, {once:true});
  } else {
    schedule();
  }
  document.addEventListener('shopify:section:load', schedule);

  /* Keep the hint in sync with the cart using the theme's own event (it carries the cart).
     Removed: the global window.fetch override. */
  document.addEventListener('theme:cart:change', function(e){
    var c = e.detail && e.detail.cart;
    if(c) renderHint(c.item_count || 0); else refreshHint();
  });
  document.addEventListener('theme:cart:reload', refreshHint);
})();
